import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginComponent } from './login/login.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthGuard } from './guard/auth.guard';
import { AuthIntercepterProvider } from './interceptor/auth.interceptor';
import { ErrorInterceptorProvider } from './interceptor/error.interceptor';
import { ToastrModule } from 'ngx-toastr';
@NgModule({
	declarations: [AppComponent, LoginComponent],
	imports: [
		BrowserModule,
		AppRoutingModule,
		BrowserAnimationsModule,
		HttpClientModule,
		RouterModule,
		FormsModule,
		ReactiveFormsModule,
		MatFormFieldModule,
		MatInputModule,
		NgbModule,
    ToastrModule.forRoot({
      positionClass: "toast-top-center",
      newestOnTop: true,
      tapToDismiss:true,
      preventDuplicates: true,
      timeOut: 1500,
      extendedTimeOut: 1000
    })
	],
	providers: [AuthGuard, AuthIntercepterProvider, ErrorInterceptorProvider],
	bootstrap: [AppComponent]
})
export class AppModule {}
